module.exports = __webpack_public_path__ + "img/a23.e79c9d2b.svg";